import { obtenerCasoByNroCaso } from "../api/casoService";
import { getHistorialFinalizados } from "../api/historialFinalizadoService";
import { HistorialFinalizado } from "../interfaces/historialFinalizado.interface";
import { InfoCaso } from "../models/caso.model";
import { Socio } from "../models/socioPrincipal.model";
import { ASISTENCIA_MEDICA } from "../utils/constants";

/**
 * Carga el historial de atenciones finalizados con la informacion proveniente de SALUS
 */
export const cargarHistorialFinalizado = (ic, apiRequest, socio, clasificaciones, servicios, canales ) => {
    return new Promise< any[] >((resolve, reject) => {
        getHistorialFinalizados(ic, apiRequest)
            .then( atenciones => {
                let atencionesMappeadas = formatearHistorialFinalizadoSalus(atenciones, socio, clasificaciones, servicios, canales);
                resolve(atencionesMappeadas);
        })
        .catch(error => {
            reject(error);
            console.error("No se pudieron recuperar las atenciones finalizados de SALUS.", error);
        });
    });
}

/**
 * Se encarga de mappear las atenciones finalizadas
 */
const formatearHistorialFinalizadoSalus = async (historialFinalizadosSalus: HistorialFinalizado[], socio, clasificaciones, servicios, canales) => {
        let arrayAtencionesMapper: any = [];
        if (historialFinalizadosSalus.length > 0) {
            //Filtra las atenciones que no deseamos mostrar en el listado de atenciones
            let arrayFiltrado = historialFinalizadosSalus.filter((atencionSalus)=> atencionSalus.recurso.codigoTipoServicio !== "GT")
            arrayAtencionesMapper = arrayFiltrado.map((atencion)=>{
                let atencionInfoCaso =  transformaCasoSalusAInfoCaso(atencion, socio, clasificaciones, servicios, canales);
                return atencionInfoCaso;
            });
        }  
        return arrayAtencionesMapper;
}

/**
 * Transforma el CasoSalus a InfoCaso
 */
const transformaCasoSalusAInfoCaso = (casoSalus: HistorialFinalizado, socioPrincipal, clasificaciones, servicios, canales) => {
    let infoCasoFinalizado = new InfoCaso();
    let socio = new Socio();
    let clasificacionSeleccionada = clasificaciones.find((clasificacion) => {
        if (clasificacion.descripcion === casoSalus.recurso.codigoSubtipoServicio &&
             clasificacion.servicio.descripcion === casoSalus.recurso.codigoTipoServicio) {
            return clasificacion;
        }
    })
    let canalSeleccionado = canales.find((canal) => {
        if (canal.codigo === casoSalus.recurso.codigoCanalEntrada) {
            return canal;
        }
    })
    socio.nombre = casoSalus.asistencia.nombre;
    socio.apellidos = casoSalus.asistencia.apellidos;
    socio.nroContrato = casoSalus.asistencia.numeroSocio;
    socio.fechaNacimiento = socioPrincipal.fechaNacimiento;
    socio.dni = socioPrincipal.dni;
    socio.email = socioPrincipal.email;
    socio.telefono = socioPrincipal.telefono;
    infoCasoFinalizado.principal = socio;
    infoCasoFinalizado.descripcion = clasificacionSeleccionada ? clasificacionSeleccionada?.clasificacionDetalle?.detalleListado : ASISTENCIA_MEDICA;
    infoCasoFinalizado.coseguro = casoSalus.coseguro;
    infoCasoFinalizado.prestador = casoSalus.recurso.prestador;
    infoCasoFinalizado.fechaCreacion = casoSalus.horaCreacion;
    infoCasoFinalizado.nroCaso = casoSalus.codigo;
    infoCasoFinalizado.estado = casoSalus.asistencia.estado;
    infoCasoFinalizado.estadoSalus = casoSalus.lCodigoUltimoEstatus; 
    infoCasoFinalizado.codigoTipoServicio = casoSalus.recurso.codigoTipoServicio;
    infoCasoFinalizado.codigoSubTipoServicio = casoSalus.recurso.codigoSubtipoServicio;
    infoCasoFinalizado.canalEntrada = canalSeleccionado.descripcion;
    infoCasoFinalizado.canalEntradaSalus = casoSalus.recurso.codigoCanalEntrada;
    return infoCasoFinalizado;
}